export default "<a [href]=\"url\" target=\"_blank\">\n  <img src=\"/assets/img/badges/Download_on_the_App_Store_Badge_US-UK_blk_092917.png\" />\n</a>"